/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LoginResponseToken } from './loginResponseToken';
import type { User } from './user';

/**
 * Response to login request
 */
export interface LoginResponse {
  token: LoginResponseToken;
  user: User;
}
